<template>
  <header class="HeaderN fixed2">
    <div class="auto">
      <div class="Logo">
        <a href='/'>
          <img src="static/picture/logo_black_eng.png" class="caise">
          <img src="static/picture/logo_weight_eng.png" class="white">
        </a>
      </div>
      <div class="MainNav" id="menuall">
        <ul>
          <li id="nav0">
            <span>
              <div>
                <a href='/'>{{ $t('nav.home') }}</a>
              </div>
            </span>
          </li>
          <li id="nav1" class="nava">
            <span><a href="/MemberCenter?currentStep=1">{{ $t('nav.orderManagement') }}</a><em class="arr"><i class="iconfont iconxjt"></i></em></span>
          </li>
          <li id="nav2" class="nava">
            <span><a href="/MemberCenter?currentStep=2">{{ $t('nav.accountSettings') }}</a><em class="arr"><i class="iconfont iconxjt"></i></em></span>
          </li>
          <li id="nav3" class="nava">
            <span><a href='/LayList'>{{ $t('nav.productsTitle') }}</a><em class="arr"><i class="iconfont iconxjt"></i></em></span>
          </li>          
          <li id="nav4" class="nava">
            <span><a href='/TechnicalService'>{{ $t('nav.serviceTitle') }}</a><em class="arr"><i class="iconfont iconxjt"></i></em></span>
          </li>
        </ul>
      </div>
      <div class="nav">
        <LangSwitcher />
        <div v-if="!authStore.isLoggedIn">
          <a href="javascript:;" class="wxLogin"><img src="static/picture/cart.png"><i>{{ $t('nav.cart') }}</i></a>
        </div>
        <div v-else>
          <div class="cart1" 		type="primary"
          @click="cartVisible = true">
          
            <img style="width: 20px;" src="static/picture/cart.png" class="white">
            <img style="width: 20px;" src="static/picture/cartlan.png" class="caise">
            <i class="iconfont iconcart"></i>{{ $t('nav.cart') }}      
            <div class="cart-count-box">
              <span class="cart-count">{{ cartStore.cartCount }}</span>
            </div>
          </div>
        </div>
        
        <div class="loginInfo">
          <div class="fm-phone-a" v-if="!authStore.isLoggedIn">
            <a href="/Login" class="login-btn">
              <i class="iconfont iconuser"></i>{{ $t('nav.login') }}
            </a>
          </div>

          <div class="cart1" v-else>
            <a href="/MemberCenter" class="a_name">
            <img style="width: 20px;" src="static/picture/userweight.png" class="caise">
            <img style="width: 20px;" src="static/picture/userblue.png" class="white">
            <i class="userName iconcart">     
                {{ $t('nav.userPrefix') }}{{ authStore.username }}  
            </i>
          </a>
            <a href="javascript:;" @click="authStore.logoutAction" class="loginOut">
              {{ $t('nav.logout') }}
            </a>
          </div>

        </div>
      </div>
    </div>
    <div class="closebtn"></div>
    <div class="clear"></div>
    <!-- 引入购物车组件 -->
     <Cart v-model:visible="cartVisible" />
  </header>
</template>

<script>
import { useAuthStore } from '@/store/index'
import {useCartStore} from '@/store/cartStore'

import Cart from "@/components/productList/Cart.vue";
import LangSwitcher from "@/components/LangSwitcher.vue";
export default {
  name: 'MemberHeader',
  methods: {
  },
  components: { Cart, LangSwitcher },
  data() {
		return {
			cartVisible: false, // 控制购物车弹窗的显示
		};
	},
  setup() {
    const authStore = useAuthStore();
    const cartStore = useCartStore();
    
    return {
      authStore,
      cartStore,
      addToCart: cartStore.addToCart,
    }
  }
};
</script>

<style scoped>
@import url(@/components/static/css/headern.css);
.login-btn {
  display: inline-flex;
  align-items: center;
  margin-left: 15px;
  color: #333;
  font-size: 14px;
}

.login-btn i {
  margin-right: 5px;
  font-size: 16px;
}

.login-btn:hover {
  color: #1086ff;
}
/* .cart1 {
  display: flex;
  align-items: center;
  margin-left: 10px;
  position: relative;
  color: white; 
} */

.iconcart {
  font-size: 18px;
  margin-right: 5px;
}

/* .cart-count-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: black;
  border-radius: 5px; 
  width: 24px;       
  height: 24px;       
  margin-left: 8px;   
} */

.cart-count {
  font-size: 14px;
  font-weight: bold; /* 数字加粗 */
}
.member-center-text {
  font-size: 16px;
  font-weight: normal;
}
/*.item {
//  margin-top: 10px;
//  margin-right: 30px;
}*/
</style>